import React from 'react';
import { Grid } from '@material-ui/core';
import LabelValue from 'eymp-uicomps/components/LabelValue';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { DOCUMENTS_CASE_COMPOSE_URL } from 'src/constants/constants';
import DOMPurify from 'dompurify';

export class DocumentBlockPres extends React.Component {
  handleOnClick() {
    window.location.href = DOMPurify.sanitize(`${DOCUMENTS_CASE_COMPOSE_URL}/${this.props.caseId}`);
  }
  render() {
    return (
      <div className="d-flex" style={{ width: '100%' }} onClick={e => this.handleOnClick()}>
        <Grid item sm={12}>
          <Grid className="header-wrap">
            <LabelValue value="DOCUMENTS" />
          </Grid>
          <Grid className="document-block-wrp cursor-pointer">
            <div>
              {this.props.activeDocumentCount !== null ? (
                <div className="d-flex align-items-center">
                  <span className="doc-count">{this.props.activeDocumentCount}</span>
                  <span className="case-doc">Case documents</span>
                </div>
              ) : (
                <div style={{ margin: 'auto' }}>
                  <Spinner size={30} />
                </div>
              )}
            </div>
            {/* <div>
              <span className="case-doc">Case documents</span>
            </div> */}
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default DocumentBlockPres;
